import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import AltusInitiateProposalPageStore, {
  ALTUS_PROPOSAL_EXPERIENCES,
  AltusInitiateProposalPageStoreContext,
  useAltusInitiateProposalPageStore,
} from 'store/pages/initiate-quote/altus/pageStore';
import AltusBasicInfoStep from 'components/initiate-quote/Altus/BasicInfoStep';
import AltusThirdStepSwitcher from 'components/initiate-quote/Altus/ThirdStepSwitcher';
import InitiateProposalPageLayout from 'components/common/initiate-proposal/InitiateProposalPageLayout';
import QuoteExperienceStep from 'components/common/initiate-proposal/QuoteExperienceStep';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate,
    bulletTabsDelegate,
    basicInfoStepController,
    proposalExperienceStepController,
    favoriteProposalStepController,
    rfqStepController,
    proposalExperience,
    getInitialData,
  } = useAltusInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <InitiateProposalPageLayout
      initiateQuoteFlowDelegate={initiateQuoteFlowDelegate}
      bulletTabsDelegate={bulletTabsDelegate}
      tabs={[
        <AltusBasicInfoStep key="0" basicInfoStepController={basicInfoStepController} />,
        <QuoteExperienceStep
          key="1"
          formController={proposalExperienceStepController.form}
          experiences={ALTUS_PROPOSAL_EXPERIENCES}
        />,
        proposalExperience && proposalExperience !== 'SHELF' && (
          <AltusThirdStepSwitcher
            key="2"
            proposalExperience={proposalExperience}
            favoriteProposalStepController={favoriteProposalStepController}
            rfqStepController={rfqStepController}
          />
        ),
      ].filter(Boolean)}
    />
  );
});

const AltusInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new AltusInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <AltusInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </AltusInitiateProposalPageStoreContext.Provider>
  );
};

export default AltusInitiateProposalPage;
